import React, {useState, useMemo} from "react";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

//components:
import TopicsEvolution from "./topicsEvolution";
import InsightsMetrics from "./Insights";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

const Metrics = () => {
    const {t} = useTranslation();
    //redux:
    //store:
    const {metricsTracksError = {}} = useSelector(state => state.settings);

    //local state:
    const [pageToShow, setPageToShow] = useState("netgraph");

    const getUpperCardContent = () => {
        const errorText = metricsTracksError?.text;

        //errors:
        if (errorText) {
            if (errorText === "No tracks")
                return (
                    <div className="alert alert-light text-dark w-fit-content">
                        {t("ADMINPANEL.METRICS.EMPTY_MESSAGE")}
                        <Link to={"/adminpanel/tracks"}>{t("ADMINPANEL.TRACKS_MANAGEMENT")}</Link>
                    </div>
                );
            else {
                return (
                    <div
                        className={`alert alert-${metricsTracksError.type ||
                            "warning"} font-weight-bold w-fit-content d-flex align-items-center`}
                    >
                        <WarningRoundedIcon color="inherit" className="mr-5" />
                        {errorText}
                    </div>
                );
            }
        }

        //content:
        return <InsightsMetrics pageToShow={pageToShow} />;
    };

    return (
        <div className="col-12 col-md-9">
            <div className="card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray justify-content-between">
                    <div className="card-title">{t("ADMINPANEL.METRICS.TITLE")}</div>
                    {!metricsTracksError?.text ? (
                        <div className="card-toolbar">
                            <ul className="nav nav-pills nav-pills-sm nav-dark-75 nav" role="tablist">
                                <li className="nav-item nav-item">
                                    <div
                                        onClick={() => setPageToShow("netgraph")}
                                        role="tab"
                                        className={`nav-link py-2 px-4 cursor-pointer ${
                                            pageToShow === "netgraph" ? "active" : ""
                                        }`}
                                    >
                                        {t("GENERAL.KNOWLEDGE_MAP")}
                                    </div>
                                </li>
                                <li className="nav-item nav-item">
                                    <div
                                        onClick={() => setPageToShow("table")}
                                        role="tab"
                                        className={`nav-link py-2 px-4 cursor-pointer ${
                                            pageToShow === "table" ? "active" : ""
                                        }`}
                                    >
                                        {t("GENERAL.TABLE")}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    ) : null}
                </div>
                <div className="card-body position-relative min-h-180px">{getUpperCardContent()}</div>
            </div>
            <TopicsEvolution />
        </div>
    );
};

export default Metrics;
